import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { ZonedDateTime } from '@js-joda/core';
import { Appearance } from '../transcript';
import { LineItem } from './LineItem';
import { LineItemType } from './LineItemType';
import { Money } from './Money';
import { UnexpectedLineItemType } from './error';
/**
 * The maximum number of emails that the user will distribute this transcript to.
 */
export const MAX_DISTRIBUTION_EMAILS = 10;
/**
 * The maximum number of appearances defined for this hearing.
 */
export const MAX_APPEARANCES = 10;
/**
 * Details of a transcript request. This contract is used when placing a new order.
 */
export class CertifiedTranscriptLineItem extends LineItem {
    constructor() {
        super(...arguments);
        this.type = LineItemType.CertifiedTranscript;
    }
}
__decorate([
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * The portions of the hearing to transcribe
     */
    )
], CertifiedTranscriptLineItem.prototype, "estimate", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", ZonedDateTime
    /**
     * Identifies the job that would be created once the invoice is paid
     */
    )
], CertifiedTranscriptLineItem.prototype, "dueBy", void 0);
__decorate([
    Type(() => Appearance),
    __metadata("design:type", Array)
], CertifiedTranscriptLineItem.prototype, "appearances", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", ZonedDateTime
    /**
     * When the transcript is considered approaching due.
     */
    )
], CertifiedTranscriptLineItem.prototype, "approachingDue", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", ZonedDateTime
    /**
     * When the transcript is due by
     */
    )
], CertifiedTranscriptLineItem.prototype, "transcriptApproachingDue", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", ZonedDateTime)
], CertifiedTranscriptLineItem.prototype, "transcriptDueBy", void 0);
export function assertIsTranscriptLineItem(lineItem, message) {
    if (!isTranscriptLineItem(lineItem)) {
        throw typeof message === 'object'
            ? message
            : new UnexpectedLineItemType(message !== null && message !== void 0 ? message : `Expected ${LineItemType.CertifiedTranscript} line item, but received ${lineItem.type} line item`);
    }
}
export function isTranscriptLineItem(lineItem) {
    return lineItem.type === LineItemType.CertifiedTranscript;
}
